import { useParams } from 'react-router-dom';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../../constants/common';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';
import { useMemo, useRef, useState } from 'react';
import { usePolling } from '../../../../../hooks/usePolling';
import { Cycle } from '../../../../../store/models/cycles';
import { filterCyclesBySearchQuery } from '../../../../ContractScreensView/utils/filterCyclesBySearchQuery';

export interface IDeletedCycles {
  cycles: Cycle[];

  isLoading: boolean;
}

export const useDeletedCycles = (): IDeletedCycles => {
  const { clientId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const {
    cycles: {
      getDeletedCyclesByLocation,
    }
  } = useAppDispatch();
  const { deletedCycles, searchCycleQuery } = useAppSelector((state) => state.cycles);

  const cycles = useMemo(() => {
    if (!searchCycleQuery) {
      return deletedCycles;
    }

    return filterCyclesBySearchQuery(deletedCycles, searchCycleQuery);
  }, [deletedCycles, searchCycleQuery]);

  const isChangeLoading = useRef(true);

  const fetchDataHandler = async (locationId: string) => {
    try {
      if (!locationId) {
        return;
      }

      if (isChangeLoading.current) {
        setIsLoading(true);
      }

      await getDeletedCyclesByLocation(locationId);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isChangeLoading.current = false;
    }
  };

  usePolling(() => fetchDataHandler(clientId), EXTENDED_INTERVAL_UPDATE_DATA, [clientId]);

  return { cycles, isLoading };
}
